export default function a10_UpdateFavoriteItems (data) {
    console.log('UPDATE_FAVORITE_ITEMS', data)
    return {
      type: 'UPDATE_FAVORITE_ITEMS',
      payload: data
    };
  };